import { dateFormatter } from "../../gridFormatters";

export const allClustersDefs = [
    {
        'field': "cluster_name",
        'headerName': "Cluster Name",
        'sort': 'asc'
    },
    {
        'field': "device_type_code",
        'headerName': "Type"
    },
    {
        "field": "collection_date",
        "headerName": "Collection Date",
        "cellRenderer": dateFormatter
    },
    {
        'field': "node_count",
        'headerName': "Nodes"
    },
    {
        "field": "pod_count",
        "headerName": "PODs"
    },
    {
        "field": "containers_count",
        "headerName": "Containers"
    }
];

export const allNodesDefs = [
    {
        'field': "node_name",
        'headerName': "Node Name",
        'sort': 'asc'
    },
    {
        'field': "device_type_code",
        'headerName': "Type"
    },
    {
        "field": "collection_date",
        "headerName": "Collection Date",
        "cellRenderer": dateFormatter
    },
    {
        "field": "node_pods_count",
        "headerName": "PODs"
    },
    {
        "field": "containers_count",
        "headerName": "Containers"
    }
];

export const allPodsDefs = [
    {
        'field': "pod_name",
        'headerName': "POD Name",
        'sort': 'asc'
    },
    {
        'field': "device_type_code",
        'headerName': "Type"
    },
    {
        "field": "collection_date",
        "headerName": "Collection Date",
        "cellRenderer": dateFormatter
    },
    {
        "field": "containers_count",
        "headerName": "Containers"
    }
];

export const allContainersDefs = [
    {
        'field': "container",
        'headerName': "Container Name",
        'sort': 'asc'
    }
];